/**
 *
 * NotesLanding
 *
 */

import { mapGetters } from 'vuex';

import { NotesDownloadMixin } from '@/scripts/Notes/mixins/NotesDownload';
import { DownloadModalMixin } from '@/scripts/Notes/NotesLanding/mixins/DownloadModal';

export default {
  name: 'DownloadNoteHistoryModal',

  mixins: [NotesDownloadMixin, DownloadModalMixin],

  data: () => {
    return {
      courseIdx: -1,
    };
  },

  computed: {
    ...mapGetters('Notes/NotesLanding', {
      mg_lstNotesGroupDisabled: 'lstNotesGroupDisabled',
    }),

    ///
    c_selectedCourseForDownload() {
      if (this.courseIdx >= 0) {
        return {
          courseId: this.mg_lstNotesGroupDisabled[this.courseIdx].course_id,
          courseName: this.mg_lstNotesGroupDisabled[this.courseIdx].course_name,
        };
      } else {
        return {};
      }
    },

    ///
    c_strSelectedBookIdsForDownload() {
      return '';
    },
  },

  methods: {
    ///
    generateFileRft(courseIdx) {
      this.courseIdx = courseIdx;
      this.doGenerateFileRft();
    },

    ///
    callbackOnModalHidden() {
      this.courseIdx = -1;
    },
  },
};
